import * as React from "react";

import {
	Button,
	Card,
	ControlGroup,
	EditableText,
	H1,
	H3,
	HTMLTable,
	InputGroup,
} from "@blueprintjs/core";
// import {handleBooleanChange} from "@blueprintjs/docs-theme";
import { css } from "glamor";
import * as _ from "lodash";

import { createJuror, getJurors, setJurorFirstname, setJurorLastname } from "../api";

import { Juror } from "src/Interfaces";
import Loading from "src/Loading";

const styles = {
	container: css({}),
	table: css({ width: "100%", tableLayout: "fixed" }),
	td: css({ verticalAlign: "middle !important" }),
	tdId: css({ width: "50px !important" }),
	inputField: css({ maxWidth: "300px" }),
	addJurorTitle: css({ textAlign: "left", marginTop: "20px !important" }),
};

const renderJurorNamePart = (namePart: string, onChange: (newNamePart: string) => void) => (
	<EditableText defaultValue={namePart} placeholder={namePart} onConfirm={onChange} />
);

export default class JurorManager extends React.Component<
	{},
	{ jurors: Juror[]; addFirstname: string; addLastname: string }
> {
	public state = { jurors: [] as Juror[], addFirstname: "", addLastname: "" };
	public async componentDidMount() {
		const jurors = Object.values(await getJurors()) as Juror[];
		this.setState({ jurors });
	}

	private onJurorLastnameConfirm = async (participantId: number, newLastname: string) => {
		if (newLastname) {
			await setJurorLastname(participantId, newLastname);
		}
	};

	private onJurorFirstnameConfirm = async (participantId: number, newFirstname: string) => {
		if (newFirstname) {
			await setJurorFirstname(participantId, newFirstname);
		}
	};

	private onAddJuror = async () => {
		const res = await createJuror(this.state.addLastname, this.state.addFirstname);
		if (res.success === true) {
			const jurors = Object.values(await getJurors()) as Juror[];
			this.setState({ jurors, addFirstname: "", addLastname: "" });
		}
	};

	public render() {
		const jurors = _.sortBy(this.state.jurors, (j) => _.trim(j.lastname.toLowerCase()));
		return (
			<div>
				<div {...styles.container}>
					{this.state.jurors.length === 0 ? (
						<Loading />
					) : (
						<div>
							<Card>
								<H1>Jurors</H1>
								<HTMLTable {...styles.table} striped={true}>
									<thead>
										<tr>
											<th {...styles.td} {...styles.tdId}>
												ID
											</th>
											<th {...styles.td}>Last name</th>
											<th {...styles.td}>First name</th>
										</tr>
									</thead>
									<tbody>
										{jurors.map((juror) => (
											<tr key={juror.id}>
												<td {...styles.tdId} {...styles.td}>
													{juror.id}
												</td>
												<td {...styles.td}>
													{renderJurorNamePart(juror.lastname, (newJurorLastname: string) =>
														this.onJurorLastnameConfirm(juror.id, newJurorLastname)
													)}
												</td>
												<td {...styles.td}>
													{renderJurorNamePart(juror.firstname, (newJurorFirstname: string) =>
														this.onJurorFirstnameConfirm(juror.id, newJurorFirstname)
													)}
												</td>
											</tr>
										))}
									</tbody>
								</HTMLTable>
								<H3 {...styles.addJurorTitle}>Add Juror:</H3>
								<form>
									<ControlGroup fill={false} vertical={false}>
										<InputGroup
											placeholder="Firstname"
											value={this.state.addFirstname}
											{...styles.inputField}
											onChange={(e: any) => this.setState({ addFirstname: e.target.value })}
										/>
										<InputGroup
											placeholder="Lastname"
											value={this.state.addLastname}
											{...styles.inputField}
											onChange={(e: any) => this.setState({ addLastname: e.target.value })}
										/>
										<Button onClick={() => this.onAddJuror()} type="submit">
											Add
										</Button>
									</ControlGroup>
								</form>
							</Card>
						</div>
					)}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Backend/JurorManager.tsx